// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-interviews-js": () => import("./../../../src/pages/interviews.js" /* webpackChunkName: "component---src-pages-interviews-js" */),
  "component---src-templates-manifest-js": () => import("./../../../src/templates/manifest.js" /* webpackChunkName: "component---src-templates-manifest-js" */),
  "component---src-templates-metadata-js": () => import("./../../../src/templates/metadata.js" /* webpackChunkName: "component---src-templates-metadata-js" */)
}

